
<fieldset class="mb-4">
        <legend>Training Details</legend>
        <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-x-3">
            <div>
                 <mat-form-field appearance="outline">
                    <mat-label>District</mat-label>
                    <mat-select>
                        <mat-option value="one">Nadia</mat-option>
                        <mat-option value="two">Block-2</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline">
                    <mat-label>Block</mat-label>
                    <mat-select>
                        <mat-option value="one">Block-1</mat-option>
                        <mat-option value="two">Block-2</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            
            <div>
                <mat-form-field appearance="outline">
                    <mat-label>GP</mat-label>
                    <mat-select>
                        <mat-option value="one">GP-1</mat-option>
                        <mat-option value="two">GP-2</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            
            <div>
                <mat-form-field appearance="outline">
                    <mat-label>Financial Year</mat-label>
                    <mat-select>
                        <mat-option value="one">2024-2025</mat-option>
                        <mat-option value="two">2023-2024</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline">
                    <mat-label>Month</mat-label>
                    <mat-select>
                        <mat-option value="one">August</mat-option>
                        <mat-option value="two">September</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="pt-1">
                <button class="mat-buttonsec btn-sec" routerLink="">
                    <span class="material-symbols-outlined">search</span>Search
                </button>
            </div>
        </div>
</fieldset>


<!-- Calendar -->
<div class="grid grid-cols-1 lg:grid-cols-3 gap-[25px] mb-[25px] ">
    <div class="lg:col-span-2">

        <!-- Calendar -->
        <div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md border-2 border-sky-600 shadow">
            <div class="trezo-card-content relative">
                <full-calendar id="fullCalendar" [options]="calendarOptions"></full-calendar>
            </div>
        </div>

    </div>
    <div class="lg:col-span-1">

        <!-- Working Schedule -->
        <app-working-schedule />

    </div>
</div>



<div class="ag-theme-alpine ag-grid-container mt-2 mb-2" style="height: calc(50vh - 100px);">
    <!-- AG Grid container -->
    <div
    #gridContainer
    class="ag-theme-Balham"
    style="height: 100%; width: 100%;"
    ></div>
</div>